import { XCircleIcon } from '@heroicons/react/24/outline';

import { EUserFlow } from '@/context/borrower';
import { setModal } from '@/context/display';
import { store } from '@/context/store';
import { useAppDispatch } from '@/context/storeHooks';

export const testId = 'ModalHeader';

export interface IProps {
    baseId: string;
    title: string;
    performCheck?: boolean;
    showCloseButton?: boolean;
    className?: string;
}

export function ModalHeader({
    title,
    baseId,
    performCheck,
    showCloseButton = true,
    className,
}: IProps): JSX.Element {
    // ***** Constants *****
    const dispatch = useAppDispatch();
    const state = store.getState();
    const instantLeadCapture =
        state.displayReducer.partner.userFlow ===
        EUserFlow.INSTANT_LEAD_CAPTURE;

    // ***** Event Handlers *****
    function handleClick(): void {
        dispatch(setModal(null));
    }

    // ***** Render *****
    return (
        <div
            data-testid={testId}
            className={`${className} _flex justify-between pb-2`}
            id={`${baseId}-modal`}
        >
            <p className='w-full font-bold'>{title}</p>
            {showCloseButton && !instantLeadCapture && (
                <div className='h-6 w-6 cursor-pointer'>
                    <XCircleIcon
                        onClick={handleClick}
                        id={`${baseId}-button-xButton`}
                    />
                </div>
            )}
        </div>
    );
}
